import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=24e1e94e&scoped=true&"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=24e1e94e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1e94e",
  null
  
)

export default component.exports